import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d0f50d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-player-notes-root-list" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "box__headline" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Dnevnik ", -1))
const _hoisted_5 = {
  key: 0,
  class: "box__list"
}
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "date" }
const _hoisted_9 = { class: "action" }
const _hoisted_10 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppPlayerNotesRootListFormCreateIndexVue = _resolveComponent("AppPlayerNotesRootListFormCreateIndexVue")!
  const _component_AppPlayerNotesRootListFormUpdateIndexVue = _resolveComponent("AppPlayerNotesRootListFormUpdateIndexVue")!
  const _component_AppPlayerNotesRootListFormRemoveIndexVue = _resolveComponent("AppPlayerNotesRootListFormRemoveIndexVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_AppPlayerNotesRootListFormCreateIndexVue, { onGetNotes: _ctx.getNotes }, null, 8, ["onGetNotes"])
      ]),
      (_ctx.notes.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notes, (note, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: note.id
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, " #" + _toDisplayString(key + 1) + " - " + _toDisplayString(note.user.content.name) + " " + _toDisplayString(note.user.content.surname), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.moment(note.created_at).format('DD.MM.YYYY.')), 1)
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_AppPlayerNotesRootListFormUpdateIndexVue, {
                    note: note,
                    onGetNotes: _ctx.getNotes
                  }, null, 8, ["note", "onGetNotes"]),
                  _createVNode(_component_AppPlayerNotesRootListFormRemoveIndexVue, {
                    note: note,
                    onGetNotes: _ctx.getNotes
                  }, null, 8, ["note", "onGetNotes"])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, " Nema podataka... "))
    ])
  ]))
}